export const faqItems = [
  {
    q: '黑料吃瓜入口是什么？',
    a: '黑料吃瓜入口是一个聚焦每日新鲜娱乐资讯与网络热点的内容聚合平台，汇集51黑料吃瓜入口、黑料吃瓜在线等多个热门入口的最新动态，让你一站式掌握全网吃瓜内容。'
  },
  {
    q: '如何找到51黑料吃瓜入口的最新内容？',
    a: '我们每日实时更新51黑料吃瓜入口和黑料吃瓜在线的最新推送，所有内容按照发布时间排列，你也可以通过首页的"今日吃瓜索引"快速定位感兴趣的话题。'
  },
  {
    q: '黑料视频在线看需要下载APP吗？',
    a: '不需要。本平台所有黑料视频均支持在线直接观看，无需安装任何软件。同时我们也提供移动端入口，在手机浏览器中访问同样流畅。'
  },
  {
    q: '51在线吃瓜今日吃瓜入口更新频率如何？',
    a: '我们保持7×24小时不间断更新，每天至少推送数十条最新黑料和吃瓜内容。热门事件发生时，相关专题会在15分钟内上线。'
  },
  {
    q: '黑料吃瓜网入口是否安全稳定？',
    a: '我们采用多节点部署方案，确保黑料吃瓜网入口的稳定性和访问速度。即使遇到高并发访问，也能保持流畅体验。所有内容经过审核，请放心浏览。'
  },
  {
    q: '如何向平台投稿或爆料？',
    a: '欢迎通过首页"投稿爆料"板块联系我们，提交你掌握的第一手黑料信息。我们会安排专人审核，一经采用将标注来源并优先展示。'
  }
];

export const cardItems = [
  {
    title: '娱乐圈最新黑料大起底',
    desc: '某当红流量小生私下行为被曝光，知情人士透露更多细节，圈内人士纷纷表态。',
    tag: '娱乐圈',
    hot: '9.8万',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20studio%20scene%20with%20warm%20spotlight%20and%20mysterious%20silhouette%2C%20dark%20cinematic%20atmosphere%2C%20editorial%20photography%20style%2C%20red%20and%20gold%20accents%2C%20professional%20lighting&width=640&height=400&seq=card-01&orientation=landscape'
  },
  {
    title: '某知名企业高管疑似内幕交易',
    desc: '内部文件流出引发市场震动，相关监管部门已介入调查，业内人士分析潜在影响。',
    tag: '财经',
    hot: '7.2万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20financial%20district%20at%20night%20with%20dramatic%20lighting%2C%20glass%20buildings%20reflecting%20warm%20golden%20light%2C%20mysterious%20atmosphere%2C%20professional%20quality%2C%20cinematic%20mood&width=640&height=400&seq=card-02&orientation=landscape'
  },
  {
    title: '某直播平台头部主播违约跳槽',
    desc: '千万级违约金纠纷持续发酵，多方势力卷入其中，平台方发布正式声明回应。',
    tag: '直播圈',
    hot: '6.5万',
    img: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20studio%20with%20dramatic%20contrast%20lighting%2C%20professional%20equipment%20in%20warm%20amber%20tones%2C%20mysterious%20vibe%2C%20editorial%20quality%2C%20dark%20background&width=640&height=400&seq=card-03&orientation=landscape'
  },
  {
    title: '网红情侣分手互撕聊天记录曝光',
    desc: '昔日恩爱如今反目成仇，双方社交媒体激烈交锋，粉丝阵营分裂引发全网讨论。',
    tag: '网红圈',
    hot: '12.1万',
    img: 'https://readdy.ai/api/search-image?query=Split%20screen%20dramatic%20composition%20with%20warm%20and%20cool%20contrasting%20tones%2C%20abstract%20emotional%20visual%2C%20modern%20digital%20art%20style%2C%20entertainment%20news%20aesthetic&width=640&height=400&seq=card-04&orientation=landscape'
  },
  {
    title: '某选秀节目黑幕被参赛选手实锤',
    desc: '淘汰选手发文揭露评审内幕，节目组紧急公关，网友翻出往期节目中的可疑细节。',
    tag: '综艺',
    hot: '8.9万',
    img: 'https://readdy.ai/api/search-image?query=Reality%20show%20stage%20with%20dramatic%20spotlight%20and%20mysterious%20shadows%2C%20theater%20atmosphere%2C%20warm%20golden%20and%20dark%20red%20tones%2C%20professional%20photography&width=640&height=400&seq=card-05&orientation=landscape'
  },
  {
    title: '某品牌代言人翻车事件全记录',
    desc: '从签约到解约仅用48小时，品牌方损失惨重，业内人士复盘事件始末与教训。',
    tag: '品牌',
    hot: '5.7万',
    img: 'https://readdy.ai/api/search-image?query=Luxury%20brand%20storefront%20at%20night%20with%20dramatic%20contrast%20lighting%2C%20broken%20display%20metaphor%2C%20warm%20amber%20and%20deep%20shadow%2C%20cinematic%20editorial%20style&width=640&height=400&seq=card-06&orientation=landscape'
  }
];

export const indexItems = [
  { title: '今日必看 · 51黑料吃瓜入口精选', count: '32条', tag: '热门', icon: 'ri-fire-line' },
  { title: '实时更新 · 黑料吃瓜在线快讯', count: '18条', tag: '最新', icon: 'ri-flashlight-line' },
  { title: '独家爆料 · 黑料独家入口首发', count: '9条', tag: '独家', icon: 'ri-vip-crown-line' },
  { title: '视频专区 · 黑料视频在线看', count: '24条', tag: '视频', icon: 'ri-movie-line' },
  { title: '深度扒皮 · 51黑料在线专题', count: '15条', tag: '深度', icon: 'ri-search-eye-line' },
  { title: '瓜友投稿 · 今日吃瓜入口精选', count: '41条', tag: '投稿', icon: 'ri-user-shared-line' },
  { title: '往期回顾 · 黑料吃瓜网入口存档', count: '200+条', tag: '存档', icon: 'ri-archive-line' }
];

export const mediaItems = [
  {
    title: '实锤！某顶流偶像与经纪人私下对话流出',
    duration: '12:36',
    views: '186万',
    img: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20dramatic%20scene%20with%20warm%20cinematic%20lighting%2C%20play%20button%20overlay%2C%20entertainment%20news%20production%2C%20dark%20moody%20background%2C%20professional%20quality&width=640&height=360&seq=media-01&orientation=landscape'
  },
  {
    title: '独家：某上市公司财务造假证据流出',
    duration: '08:22',
    views: '142万',
    img: 'https://readdy.ai/api/search-image?query=Corporate%20office%20dramatic%20scene%20with%20warm%20amber%20and%20shadow%20contrast%2C%20mysterious%20documents%2C%20cinematic%20mood%2C%20professional%20production%20quality%2C%20dark%20background&width=640&height=360&seq=media-02&orientation=landscape'
  },
  {
    title: '复盘：某网红直播翻车全程高能',
    duration: '15:47',
    views: '203万',
    img: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20tense%20moment%20with%20dramatic%20red%20and%20golden%20lighting%2C%20abstract%20digital%20art%2C%20entertainment%20production%2C%20cinematic%20feel%2C%20dark%20mood&width=640&height=360&seq=media-03&orientation=landscape'
  },
  {
    title: '解密：娱乐圈资本局中局大起底',
    duration: '22:10',
    views: '97万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20mysterious%20financial%20deal%20scene%20with%20dramatic%20shadows%20and%20warm%20golden%20accents%2C%20cinematic%20quality%2C%20entertainment%20industry%20atmosphere%2C%20dark%20sophisticated%20mood&width=640&height=360&seq=media-04&orientation=landscape'
  }
];

export const featureItems = [
  {
    title: '全网最快更新',
    desc: '7×24小时不间断监控各大平台，热门黑料第一时间推送，绝不让你错过任何精彩内容。',
    icon: 'ri-speed-up-line'
  },
  {
    title: '多入口稳定访问',
    desc: '覆盖51黑料吃瓜入口、黑料吃瓜在线等全部热门入口，多节点部署确保随时随地稳定访问。',
    icon: 'ri-shield-check-line'
  },
  {
    title: '独家内容首发',
    desc: '与多位圈内人士保持紧密联系，黑料独家入口为你带来第一手未经修饰的独家爆料。',
    icon: 'ri-sparkling-line'
  },
  {
    title: '高清视频在线看',
    desc: '黑料视频在线看功能支持高清画质播放，无需下载任何软件，打开浏览器即可畅享吃瓜内容。',
    icon: 'ri-4k-line'
  },
  {
    title: '严格内容审核',
    desc: '所有51黑料在线内容均经过多轮审核，确保信息真实可靠，拒绝虚假消息和恶意造谣。',
    icon: 'ri-check-double-line'
  }
];

export const updateItems = [
  { time: '2分钟前', text: '某知名导演新片选角内幕被曝光，多位一线演员涉及其中，制片方尚未回应。', tag: '娱乐圈' },
  { time: '18分钟前', text: '黑料独家入口独家发布：某电商平台数据造假证据链完整流出。', tag: '独家' },
  { time: '42分钟前', text: '51黑料吃瓜入口更新：某短视频平台头部网红因税务问题被约谈。', tag: '财经' },
  { time: '1小时前', text: '黑料吃瓜在线快讯：某综艺节目录制现场发生冲突，工作人员爆料内情。', tag: '综艺' },
  { time: '2小时前', text: '今日吃瓜入口推荐：网红圈年度最大反转事件全梳理，看完直呼精彩。', tag: '网红圈' },
  { time: '3小时前', text: '51在线吃瓜今日吃瓜入口更新：某品牌代言人解约风波持续，品牌股价大跌。', tag: '品牌' },
  { time: '5小时前', text: '黑料吃瓜网入口精选：娱乐圈资本运作大揭秘，背后关系网令人震惊。', tag: '深扒' }
];

export const topicItems = [
  { name: '某顶流塌房', hot: '爆', count: '328万' },
  { name: '直播带货翻车', hot: '热', count: '256万' },
  { name: '明星税务问题', hot: '热', count: '198万' },
  { name: '品牌解约潮', hot: '热', count: '175万' },
  { name: '选秀黑幕', hot: '新', count: '142万' },
  { name: '网红互撕', hot: '热', count: '118万' },
  { name: '影视圈潜规则', hot: '热', count: '96万' },
  { name: '高管内幕交易', hot: '新', count: '87万' },
  { name: '综艺造假', hot: '热', count: '73万' },
  { name: '粉丝经济乱象', hot: '热', count: '65万' },
  { name: '代言人翻车', hot: '新', count: '52万' }
];

export const commentItems = [
  {
    user: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20geometric%20avatar%20with%20circular%20composition%2C%20minimal%20style%2C%20soft%20golden%20and%20crimson%20gradient%2C%20simple%20modern%20design&width=80&height=80&seq=avatar-01&orientation=squarish',
    text: '这个瓜我吃了三天了，越吃越上头。51黑料吃瓜入口的信息更新速度真的快，比别的平台至少早半天！',
    time: '3小时前',
    likes: '2.1万'
  },
  {
    user: '前排围观群众',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20geometric%20avatar%20with%20hexagonal%20composition%2C%20minimal%20style%2C%20soft%20amber%20and%20deep%20red%20gradient%2C%20simple%20modern%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    text: '黑料视频在线看画质是真的好，之前在其他地方找的资源都糊得不行，这里直接高清看完整版。',
    time: '5小时前',
    likes: '1.8万'
  },
  {
    user: '资深瓜农',
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20geometric%20avatar%20with%20diamond%20composition%2C%20minimal%20style%2C%20soft%20crimson%20and%20golden%20gradient%2C%20simple%20modern%20design&width=80&height=80&seq=avatar-03&orientation=squarish',
    text: '推荐给身边所有爱吃瓜的朋友了，黑料吃瓜网入口真的是宝藏站点，每日必刷！',
    time: '8小时前',
    likes: '3.5万'
  }
];

export const rankingItems = [
  { rank: 1, title: '某顶流偶像与经纪人私下对话实锤录音', hot: '328万', trend: 'up' },
  { rank: 2, title: '知名企业高管内幕交易文件完整流出', hot: '256万', trend: 'up' },
  { rank: 3, title: '网红情侣互撕聊天记录全曝光', hot: '198万', trend: 'up' },
  { rank: 4, title: '选秀节目评审黑幕参赛选手实锤', hot: '175万', trend: 'up' },
  { rank: 5, title: '直播平台头部主播千万违约金内幕', hot: '142万', trend: 'new' }
];

export const carouselItems = [
  {
    title: '51黑料吃瓜入口 · 本周重磅专题',
    desc: '深度梳理娱乐圈资本局中局：从对赌协议到阴阳合同，揭秘明星背后的商业帝国运作逻辑。',
    tag: '深度专题',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20composition%20with%20warm%20golden%20and%20deep%20crimson%20gradients%2C%20abstract%20entertainment%20industry%20visual%2C%20luxurious%20yet%20mysterious%20atmosphere%2C%20editorial%20quality%2C%20wide%20panoramic%20style&width=1200&height=500&seq=carousel-01&orientation=landscape'
  },
  {
    title: '黑料视频在线看 · 月度最热合集',
    desc: '本月播放量最高的20条独家视频一次看完：从明星塌房到商业黑幕，全程高能不断。',
    tag: '视频合集',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20video%20montage%20concept%20with%20dramatic%20warm%20lighting%2C%20multiple%20floating%20frames%2C%20entertainment%20production%20aesthetic%2C%20dark%20moody%20background%2C%20professional%20quality&width=1200&height=500&seq=carousel-02&orientation=landscape'
  },
  {
    title: '今日吃瓜入口 · 24小时热点追踪',
    desc: '过去24小时内最值得关注的8条黑料新闻，从娱乐圈到财经圈，全网热点一站掌握。',
    tag: '热点追踪',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20headline%20news%20collage%20style%20with%20warm%20crimson%20and%20golden%20accents%2C%20abstract%20information%20flow%2C%20modern%20editorial%20design%2C%20dark%20sophisticated%20atmosphere&width=1200&height=500&seq=carousel-03&orientation=landscape'
  },
  {
    title: '黑料独家入口 · 圈内人爆料专区',
    desc: '多位圈内知情人士匿名投稿，揭露娱乐圈不为人知的另一面。内容敏感，建议收藏后观看。',
    tag: '圈内爆料',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20anonymous%20insider%20reveal%20concept%20with%20dramatic%20shadows%20and%20warm%20golden%20light%2C%20secretive%20atmosphere%2C%20cinematic%20quality%2C%20dark%20and%20intriguing%20mood&width=1200&height=500&seq=carousel-04&orientation=landscape'
  }
];